import { render, staticRenderFns } from "./ConfirmPetition.vue?vue&type=template&id=02b54582"
import script from "./ConfirmPetition.vue?vue&type=script&lang=js"
export * from "./ConfirmPetition.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPetition.vue?vue&type=style&index=0&id=02b54582&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports